module.exports = __webpack_public_path__ + "img/ios_padlock.11d6886c.png";